export default __webpack_public_path__ + "static/media/circle_bandwagon.08392101.png";